var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',_vm._l((_vm.distributionList),function(distribution,index){return _c('b-col',{key:index,staticClass:"col-xxl-6",attrs:{"cols":"12"}},[_c('distribution-reservation-item',{attrs:{"distribution":distribution}})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }